// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".text-component-title{padding-bottom:35px}.text{opacity:.8}.text img{width:100%!important;height:600px!important;-o-object-fit:cover;object-fit:cover;margin:40px 0;border-radius:5px}@media (max-width:766px){.text img{height:400px!important}}", ""]);
// Exports
module.exports = exports;
